export default class InputMask {

    public phoneMask(phoneNumber: any) {
        const regex = phoneNumber.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        const masked = !regex[2] ? regex[1] : '(' + regex[1] + ') ' + regex[2] + (regex[3] ? '-' + regex[3] : '');
        return masked;
    }

}



// WEBPACK FOOTER //
// ./src/Services/InputMask/InputMask.tsx